import { render, staticRenderFns } from "./BookView.vue?vue&type=template&id=a42a4b6a&scoped=true&"
import script from "./BookView.vue?vue&type=script&lang=js&"
export * from "./BookView.vue?vue&type=script&lang=js&"
import style0 from "./BookView.vue?vue&type=style&index=0&id=a42a4b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42a4b6a",
  null
  
)

export default component.exports